const SITE = process.env.REACT_APP_SITE_URL || "https://azglassgroup.az";

export const buildServiceJsonLd = ({ title, description, path }) => {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: title,
    description,
    provider: {
      "@type": "Organization",
      name: "AzGlass Group Construction",
      url: SITE,
    },
    url: `${SITE}${path}`,
  };
};